import { useFormikContext } from 'formik';
import { pluck } from '../../helpers/pluck';

type Option = {
  value: string;
  label: string;
  valueOption?: string;
  disabled?: boolean;
};

type ComboBoxFormikProps = {
  name: string;
  label?: string;
  options: Option[];
  className?: string;
  required?: boolean;
  onChange?: (value: string | unknown) => void;
  disabled?: boolean;
  value?: string; // Adiciona a propriedade opcional value
  placeholder?: string;
};


const ComboBoxFormik: React.FC<ComboBoxFormikProps> = ({
  name,
  label,
  options,
  disabled,
  className,
  required,
  onChange,
  value,
  placeholder,
}) => {
  const { handleChange, values, errors } = useFormikContext<Record<string, unknown>>();

  const selectedValue = value ?? (pluck(name, values) as string) ?? '';

  const combinedHandleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    handleChange(event);
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <div className={`mb-2 ${className}`}>
      <label htmlFor={name} className="block font-medium text-[16px] text-gray-600">
        {label || ''} &nbsp; {required ? <b className="text-redPrimary">*</b> : ' '}
      </label>
      <select
        id={name}
        name={name}
        onChange={combinedHandleChange}
        value={selectedValue}
        className="border p-2 rounded w-full bg-[ffffff]"
        aria-required={required}
        aria-invalid={Boolean(pluck(name, errors))}
        disabled={disabled}
      >
        {placeholder && !selectedValue && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value} disabled={option.disabled}>
            {option.label}
          </option>
        ))}
      </select>
      {pluck(name, errors) ? (
        <small className="text-redPrimary/90" aria-live="polite">
          {pluck(name, errors)}
        </small>
      ) : null}
    </div>
  );
};


export default ComboBoxFormik;
